import { SESSION_KEYS } from '@constants/index';
import { LocalPersistence } from '@factories/Mutations';
import axios, { AxiosError } from 'axios';
import { getSession, pingLogOut } from '../ping';

// Language Id Feature
axios.interceptors.request.use(
  function (config: any) {
    const whiteListApis = ['property', 'basicinformation'];
    const langId = window.sessionStorage.getItem('langId');
    if (!langId) return config;

    if (config.method === 'get') {
      const whiteList = whiteListApis
        .map((url) => config.url.includes(url) && !config.url.includes('chain'))
        .filter((url) => url);

      if (whiteList.length > 0 && langId) {
        config.url = config.url + `&langId=${langId}`;
        return config;
      }
    }

    if (config.method === 'post' || config.method === 'put') {
      config.data.langId = langId;
      return config;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error: AxiosError) => {
    const { data, status } = error.response!;
    let defaultErrorCode: string = 'CM_1004';

    switch (status) {
      case 401:
        console.error(error);
        // @ts-expect-error - killing the session
        window.sessionStorage.setItem('session', { loggedIn: false });
        return getSession();
      //if anything goes wrong just display 403
      case 403:
        let forbiddenErrorCode: string = defaultErrorCode;

        //if we call the search filter and it fails, reset searchfilterParameters to avoid going back to a failed search
        if (data.path?.includes('search'))
          window.sessionStorage.setItem(
            SESSION_KEYS.PROPERTY_PARAMS_SESSION,
            JSON.stringify({ propertyid: '', selectedSupplier: '' })
          );

        if (data.errors)
          forbiddenErrorCode = geterrorCode(data.errors, forbiddenErrorCode);
        console.error(error);
        window.location.href = `/forbidden/${forbiddenErrorCode}`;
        throw Error(` error -> ${error}`);
      default:
        let anyErrorCode: string = defaultErrorCode;

        //if we call the search filter and it fails, reset searchfilterParameters to avoid going back to a failed search
        if (data.path?.includes('search'))
          window.sessionStorage.setItem(
            SESSION_KEYS.PROPERTY_PARAMS_SESSION,
            JSON.stringify({ propertyid: '', selectedSupplier: '' })
          );

        if (data.errors) anyErrorCode = geterrorCode(data.errors, anyErrorCode);
        window.location.href = `/server-error/${anyErrorCode}`;

        return Promise.reject(error.response);
    }
    return Promise.reject(error.response);
  }
);

const geterrorCode = (errors: any[], errorCode: string): string => {
  errors.forEach((value: any, index: number) => {
    if (value['value'] === 'code') errorCode = value['message'];
  });
  return errorCode;
};

const logOut = async (session: any) => {
  return await pingLogOut({ token: session.token });
};

const handleBackButton = async () => {
  const get_session = new LocalPersistence('session');
  const session = await get_session.getSessionPersistence();
  const login: string = 'login';
  const userManagement: string = 'usermanagement';

  const { origin } = window.location;
  const previousUrl: string = document.referrer;
  const url: string[] = previousUrl.split('/');

  let previousUrlPath: string = '';

  url.forEach((value: string) => {
    let urlValueToLowerCase: string = value.toLowerCase();
    if (urlValueToLowerCase === login) {
      previousUrlPath = urlValueToLowerCase;
    } else if (urlValueToLowerCase === userManagement) {
      previousUrlPath = urlValueToLowerCase;
    }
  });

  switch (previousUrlPath) {
    case userManagement:
      window.location.href = `${origin}/listing`;
      break;
    case login:
      logOut(session);
      break;
    default:
      window.history.back();
  }
};

export { axios, handleBackButton };
